/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import type { Seo_ComponentLink as SeoComponentLink } from '__generated__/graphql-types';

import { Grid, Link, Typography } from '@coursera/cds-core';

import { TrackedLink2 } from 'bundles/page/components/TrackedLink2';

type Props = {
  links: SeoComponentLink[];
  header: string;
};

const styles = {
  heading: () => css`
    padding: var(--cds-spacing-300) 0;
  `,
};

export const SeoRelatedSearches = ({ links, header }: Props) => {
  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography css={styles.heading} variant="h2semibold">
          {header}
        </Typography>
      </Grid>
      <Grid item container xs={12} spacing={12}>
        {links.map(({ id, label, href }) => (
          <Grid item xs={12} sm={6} key={id}>
            <Link
              variant="quiet"
              rel="nofollow"
              href={href}
              typographyVariant="subtitleMedium"
              component={TrackedLink2}
              trackingName="seo_suggested_searches"
            >
              {label}
            </Link>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default SeoRelatedSearches;
